<template>
  <b-modal size="xl" button-size="sm" :title="prefix + title" v-model="showModal" @hidden="cancelar" hide-footer>

    <b-card>
      <b-card bg-variant="light">
        <div>
          <span style="font-size: 16px;">

            <strong>Nº Solicitação:</strong> {{ form.solicitacaoMovimentacao.id }} <br>
            <strong>Data:</strong> {{ this.formatarData() }} <br>

            <strong>Solicitante:</strong> {{ form.codDepartamento.descricao }}<br>
            <strong>Tarefa:</strong> {{ form.codTipoTarefaSolMovIbp.descricao }}<br>
            <strong>Status:</strong> {{ form.codStatus.descricao }} <br>
            <strong>Excecução Entrega:</strong> {{ form.codPessoa?form.codPessoa.nome: "" }} <br>

            <b-row class="pl-3">
              <strong>Parecer:*</strong> <span v-if="isVisualizacao"></span>
              <lg-form-select v-else v-model="form.codTipoParecer" :loadFunction="tipoParecerList"
                labelFormGroupBind=" " label="descricao" cols="4" invalidFeedback=" " description=" " />
            </b-row>

            <b-row class="pl-3" v-if="!isVisualizacao && isAprovacaoDestino()">

              <strong>Replicar localização física destino:</strong>
              <lg-finder-page-local-armazenamento :prefix="prefix + title + ' > '" class="mt-2"
                :departamento="form.codDepartamento" v-model="localArmazenamentoAprovacaoEntrega"
                @input="selecionarLocalPrincipal" :podeMudar="!isVisualizacao"
                :podeApagar="!isVisualizacao && !isAprovacaoDestino()" :id="'finderPageLocalArmazenamentoPrincipal'"
                label="" />
            </b-row>

          </span>
        </div>
      </b-card>

      <b-card bg-variant="light" style="z-index: 500;">

        <b-table style="z-index: 500;" head-variant="dark" responsive class="mt-2" small :busy="busy" :items="form.itens"
          :fields="tableTarefasFields" :hover="true">

          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template v-slot:cell(localizacao)="row">

            <lg-finder-page-local-armazenamento class="mt-3" :prefix="prefix + title + ' > '" :departamento="form.codDepartamento"
              v-model="row.item.localArmazenamentoAprovacaoEntrega"
              @input="function (local) { row.item.localArmazenamentoAprovacaoEntrega = local }"
              :podeApagar="!isVisualizacao && isAprovacaoDestino()" :podeMudar="!isVisualizacao && isAprovacaoDestino()"
              :id="'finderPageLocalArmazenamento' + row.item.id" label="" />

          </template>

          <template v-slot:cell(complemento)="row">
            <b-button v-if="isAprovacaoResponsavel()" :id="row.index + 'complemento-button'" class="my-2" size="sm" pill
              variant="primary" @click="abrirModalComplemento(row.item)">
              <b-icon icon="pencil-square" />
              <b-tooltip :target="row.index + 'complemento-button'" title="Detalhar..."></b-tooltip>
            </b-button>
          </template>


          <template v-slot:cell(selecionar)="row">
            <b-form-checkbox v-if="!isVisualizacao && isAprovacaoDestino()"
              :id="'checkboxSelecionarTodos' + row.item.id" :disabled="isVisualizacao" v-model="row.item.selecionado"
              size="lg" :value="true" :unchecked-value="false" />
          </template>

          <template v-slot:cell(visualizar)="row">

            <b-button :id="row.index + 'visualizar-button'" class="my-2" size="sm" pill variant="primary"
              @click="abrirModalConsultaIBP(row.item)">
              <b-icon icon="eye" />
              <b-tooltip :target="row.index + 'visualizar-button'" title="Detalhar..."></b-tooltip>
            </b-button>
          </template>

        </b-table>

        <b-col lg="12" sm="12" class="text-left">
          <b-form-group label-for="textarea-formatter" class="col-12">
            <label for="textarea-auto-height">Observação:</label>
            <b-form-textarea :disabled="isVisualizacao" v-model="form.obs">
            </b-form-textarea>
          </b-form-group>
        </b-col>

      </b-card>

      <div class="d-flex w-100 justify-content-center">
        <b-button id="salvar" variant="success" size="sm" pill class="ml-2" @click="salvar" v-if="!isVisualizacao">
          <b-tooltip target="salvar" title="Salvar"></b-tooltip>
          <div class="btn-size-alinhamento">
            <b-icon icon="check2-circle" scale="1.5" />
          </div>
        </b-button>
        <b-button id="concluir" variant="primary" size="sm" pill class="ml-2" @click="concluir" v-if="!isVisualizacao">
          <b-tooltip target="concluir" title="Proxima Tarefa"></b-tooltip>
          <b-icon icon="arrow-right" />
        </b-button>
        <b-button id="cancelar" variant="danger" size="sm" pill class="ml-2" @click="cancelar">
          <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>
          <div class="btn-size-alinhamento">
            <b-icon icon="x-circle" />
          </div>
        </b-button>
      </div>

    </b-card>

    <ModalComplemento :isVisualizacao="isVisualizacao" :id="itemBemPermanenteId" @close="fecharModalComplemento"
      v-if="mostrarModalComplemento" :prefix="prefix + title + ' > '"></ModalComplemento>

    <ModalItemBemPermanenteView v-if="mostrarConsultaIBP" :isEdit="false" :id="idItemBemPermanente"
      @fecharModal="fecharModalConsultaIBP" :prefix="prefix + title + ' > '" :title="'Cadastro'" />
  </b-modal>

</template>
<script>
import ModalItemBemPermanenteView from '@/core/components/Modals/ModalItemBemPermanenteView.vue'
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import ResourceService from "@/core/api/ResourceService";
import Formatters from "@/core/mixins/formatters";
import moment from "moment";
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue";

import { ListResourceMixin } from "@/core/mixins/resource";
import { FormResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm";
import GrupoParecerEnum from '@/core/utils/GrupoParecerEnum';
import TipoTarefaSolMovIBPEnum from '@/core/utils/TipoTarefaSolMovIBPEnum';
import TipoParecerSolMovIBPEnum from '@/core/utils/TipoParecerSolMovIBPEnum';
import ModalComplemento from '@/core/components/Modals/ModalComplemento.vue';


export default {
  mixins: [Formatters, ConfirmMixin, ListResourceMixin, FormResourceMixin],

  props: {
    id: Number,
    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Tarefa",
    },
    isVisualizacao: {
      type: Boolean,
      defaulta: false,
    }
  },
  components: {
    ModalComplemento,
    ModalItemBemPermanenteView,
    LgFormSelect,
    LgFinderPageLocalArmazenamento
  },

  data() {
    return {
      itemBemPermanenteId: null,
      mostrarModalComplemento: false,
      localArmazenamentoAprovacaoEntrega: {},
      mostrarConsultaIBP: false,
      showModal: true,
      idItemBemPermanente: null,
      form: {

        id: "",
        solicitacaoMovimentacao: {},
        dhCriacao: "",
        codDepartamento: { descricao: "" },
        codPessoa: { nome: "" },
        codTipoTarefaSolMovIbp: { descricao: "" },
        codStatus: { descricao: "" },
        itens: [],
        obs: ""
      },

    };
  },



  async beforeMount() {

    this.$service = new ResourceService(`/api/tarefa-solmovibp`);
    this.$tipoParecer = new ResourceService("/api/tipo-parecer")

    var { data } = await this.$service.findById(this.id);

    data.itens.forEach(item =>
      item.localArmazenamentoAprovacaoEntrega = item.localArmazenamentoAprovacaoEntrega && item.localArmazenamentoAprovacaoEntrega.id > 0 ? item.localArmazenamentoAprovacaoEntrega : {}
    );

    this.busy = false;
    this.form = data;



  },



  computed: {

    tableTarefasFields() {
      return [
        { key: "itemBemPermanente.numTombamento", label: "Nº Tombamento" },
        { key: "itemBemPermanente.itemRegEntrada.produto.numero", label: "Número" },
        {
          key: "itemBemPermanente.itemRegEntrada.produto.descricaoResumida",
          label: "Descrição",
        },
        { key: "departamentoOrigem.descricao", label: "Origem" },

        { key: "localizacao", label: "Localização", },
        { key: "departamentoDestino.descricao", label: "Destino", },

        { key: "selecionar", label: " ", },
        { key: "complemento", label: " ", },

        { key: "visualizar", label: " ", },

      ];

    },

  },

  methods: {
    abrirModalComplemento(item) {
      this.mostrarModalComplemento = true;
      this.itemBemPermanenteId = item.itemBemPermanente.id;

    },
    fecharModalComplemento() {
      this.mostrarModalComplemento = false;
    },


    isAprovacaoResponsavel() {
      return this.form.codTipoTarefaSolMovIbp.id == TipoTarefaSolMovIBPEnum.APROVACAO_RESPONSAVEL.value;
    },

    isAprovacaoDestino() {
      return this.form.codTipoTarefaSolMovIbp.id == TipoTarefaSolMovIBPEnum.APROVACAO_DESTINO.value;
    },
    selecionarLocalPrincipal(local) {
      this.localArmazenamentoAprovacaoEntrega = local;
      this.form.itens.forEach(item => item.localArmazenamentoAprovacaoEntrega = local);
    },
    async tipoParecerList({ page = 1 }) {
      var params = {}
      params.situacao = 1;
      params.grupo = GrupoParecerEnum.SOLICITACAO_MOVIMENTACAO_IBP.value;
      return this.$tipoParecer.findAll({ params, page, limit: 5 });
    },
    fecharModalConsultaIBP() {
      this.mostrarConsultaIBP = false;
    },
    abrirModalConsultaIBP(item) {
      this.mostrarConsultaIBP = true;
      this.idItemBemPermanente = item.itemBemPermanente.id;

    },
    formatarData() {
      return this.form.dhCriacao == "" ? "" : moment(String(this.form.dhCriacao)).format(
        "DD/MM/YYYY HH:mm"
      )
    },
    async concluir() {

      if (!this.form.codTipoParecer || !this.form.codTipoParecer.id) {
        this.busy = false;
        this.$notify({
          type: "danger",
          message: "Preencha os campos corretamente",
        });
        return;

      }


      if (this.form.codTipoTarefaSolMovIbp.id == TipoTarefaSolMovIBPEnum.APROVACAO_DESTINO.value) {
        var erro = false;
        this.form.itens.forEach(item => {

          if (this.form.codTipoParecer.id != TipoParecerSolMovIBPEnum.REPROVADO.value && (!item.localArmazenamentoAprovacaoEntrega || !item.localArmazenamentoAprovacaoEntrega.id)) {
            erro = true;
          }

        });

        if (erro) {
          this.$notify({
            type: "danger",
            message: 'Informe a Localização de Destino para dar sequência na Movimentação de Bens.',
          });
          return;

        }

      }

      try {
        this.busy = true;

        await this.$service.put(this.form.id, this.form);


        var itens = this.form.itens.filter(item => item.selecionado);

        if (this.isAprovacaoDestino()) {
          if (itens.length == 0) {
            this.$notify({
              type: "danger",
              message: "Preencha os campos corretamente",
            });
            return;

          }

          this.form.itens = itens;
        }
        await this.$service.put("executa-proxima-tarefa/" + this.form.id, this.form);
        this.busy = false;
        this.$notify({
          type: "success",
          message: `Tarefa (${this.form.codTipoTarefaSolMovIbp.descricao}) finalizada com sucesso`,
        });
        this.cancelar();

      } catch (error) {
        this.busy = false;
        this.$notify({
          type: "danger",
          message: error,
        });
      }


    },
    async salvar() {

      if (!this.form.codTipoParecer || !this.form.codTipoParecer.id) {
        this.busy = false;
        this.$notify({
          type: "danger",
          message: "Preencha os campos corretamente",
        });
        return;

      }

      try {
        this.busy = true;
        await this.$service.put(this.form.id, this.form);
        this.busy = false;
        this.$notify({
          type: "success",
          message: 'Edição salva com sucesso! Caso deseje finalizar a tarefa, clique na "seta azul", o botão "Proseguir para a próxima tarefa" ',
        })

      } catch (error) {
        this.busy = false;
        this.$notify({
          type: "danger",
          message: error,
        });
      }


    },

    cancelar() {
      this.$emit("close")
    },

  },
};

</script>
